import React, { useState } from 'react';
import { connect } from 'react-redux';

import Modal from 'react-modal';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Row';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';

import moment from 'moment';
import emailjs from 'emailjs-com';

import { FaCircle } from 'react-icons/fa';
import { IconContext } from "react-icons";

import './EditProject.css';
import { updateProjectDetail } from '../../../../../store/actions/projectActions';

const customStyles = {
  content : {
    top                   : '47%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)',
    maxHeight: "88vh",
    overflowY: "auto",
  },
  overlay                 : {zIndex: 100}
};

const makeBlankContacts = () => ({
  primary: { nameTitle: '', phone: '' },
  alternate: { nameTitle: '', phone: '' },
  onsite: { nameTitle: '', phone: '' },
});

//Modal.setAppElement('#yourAppElement')

function EditProject(props){

  const editedProjectValues = { client: '', alias: '', address: '',
                            city: '', addressLink: '', workstations: '',
                            type: '', startTime: '', endTime: '',
                            bartStation: '', bartDistance: '',
                            notes: '',
                            contacts: makeBlankContacts() };

  const [editedProjectState, setEditedProjectState] = useState({...editedProjectValues});

  var subtitle;
  const [modalIsOpen,setIsOpen] = React.useState(false);

  function openModal() {
    setIsOpen(true);
  }

  function afterOpenModal() {
    subtitle.style.color = '#f00';
  }

  function closeModal(){
    setIsOpen(false);
  }

  function handleEditProject(e) {
    const updatedProjects = {...editedProjectState};
    updatedProjects[e.target.id] = e.target.value;
    setEditedProjectState(updatedProjects)
  }

  function handleContactEdit(e) {
    const contactType = e.target.dataset.contactType; // primary|alternate|onsite
    const field = e.target.dataset.field; // nameTitle|phone
    const value = e.target.value;

    const updated = { ...editedProjectState };
    updated.contacts = { ...updated.contacts };
    updated.contacts[contactType] = { ...updated.contacts[contactType] };
    updated.contacts[contactType][field] = value;

    setEditedProjectState(updated);
  }

  function checkIfFilled(values) {
    var anythingChanged = false

    values.forEach(value => {
      if (value) {
        anythingChanged = true
      }
    })
    return anythingChanged
  }

  function contactsChanged(contactsObj) {
    if (!contactsObj) return false;

    var p = contactsObj.primary || {};
    var a = contactsObj.alternate || {};
    var o = contactsObj.onsite || {};

    return (
      (p.nameTitle && p.nameTitle.length) ||
      (p.phone && p.phone.length) ||
      (a.nameTitle && a.nameTitle.length) ||
      (a.phone && a.phone.length) ||
      (o.nameTitle && o.nameTitle.length) ||
      (o.phone && o.phone.length)
    );
  }

  function discardChanges() {
    setEditedProjectState({...editedProjectValues})
    closeModal()
  }

  function confirmChanges(project) {
    Object.entries(editedProjectState).forEach(entry => {
      const key = entry[0]
      const value = entry[1]

      // contacts handled below as one update
      if (key === "contacts") return;

      if (value) {
        // Firebase specific checks
        if (key === "startTime" || key === "endTime") {
          const time = moment(project.startTime, "YYYY-MM-DD hh:mm").format('YYYY-MM-DD') + ' ' + value
          props.updateProjectDetail(project.refLocation, key, time)
        } else {
          props.updateProjectDetail(project.refLocation, key, value)
        }

        // EmailJS specific checks
        if ((key === "startTime" || key === "address") && project.phase === "confirmed") {

          var IDsToUpdate = Object.keys(project.confirmedTechList);
          var emailsToUpdate = [];

          IDsToUpdate.forEach(id => {
            if (props.users[id].notifications.email.projectUpdated) {
              emailsToUpdate.push(props.users[id].email)
            }
          })

          var templateParams = { Bcc: emailsToUpdate }
          emailjs.send('scheduler@murphymckay', 'template_6dgpdja', templateParams, "user_UgmdOeeH6OCjwrAqPoGpi")
          .then((result) => {
              console.log(result.text);
          }, (error) => {
              console.log(error.text);
          });
        }

      }
    })

    // update contacts once (merge so blanks don't erase old values)
    if (contactsChanged(editedProjectState.contacts)) {
      var existing = project.contacts ? project.contacts : makeBlankContacts();

      var merged = {
        primary: {
          nameTitle:
            editedProjectState.contacts.primary.nameTitle ||
            (existing.primary ? existing.primary.nameTitle : ''),
          phone:
            editedProjectState.contacts.primary.phone ||
            (existing.primary ? existing.primary.phone : ''),
        },
        alternate: {
          nameTitle:
            editedProjectState.contacts.alternate.nameTitle ||
            (existing.alternate ? existing.alternate.nameTitle : ''),
          phone:
            editedProjectState.contacts.alternate.phone ||
            (existing.alternate ? existing.alternate.phone : ''),
        },
        onsite: {
          nameTitle:
            editedProjectState.contacts.onsite.nameTitle ||
            (existing.onsite ? existing.onsite.nameTitle : ''),
          phone:
            editedProjectState.contacts.onsite.phone ||
            (existing.onsite ? existing.onsite.phone : ''),
        },
      };

      props.updateProjectDetail(project.refLocation, "contacts", merged);
    }

    setEditedProjectState({...editedProjectValues})
    closeModal()
  }

  const { title, project } = props;

  // current contacts (safe)
  var currentContacts = project.contacts ? project.contacts : makeBlankContacts();
  var curPrimary = currentContacts.primary ? currentContacts.primary : { nameTitle: '', phone: '' };
  var curAlternate = currentContacts.alternate ? currentContacts.alternate : { nameTitle: '', phone: '' };
  var curOnsite = currentContacts.onsite ? currentContacts.onsite : { nameTitle: '', phone: '' };

  // enable button if normal OR contacts changed
  var anythingChanged = checkIfFilled(
    Object.values(editedProjectState).filter((v, i) => Object.keys(editedProjectState)[i] !== 'contacts')
  ) || contactsChanged(editedProjectState.contacts);

  return (
    <div>
      <Button onClick={openModal}>
          Edit
      </Button>

      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Warning Modal"
        shouldCloseOnOverlayClick={false}
      >

      <h2 ref={_subtitle => (subtitle = _subtitle)}>{title}</h2>

      <Container>
        <Row style={{marginLeft: 0, marginRight: 0}}>
          <Col style={{marginLeft: 0, marginRight: 0}}>
              <Card style={{marginLeft: 20, marginRight: 20, padding: 20}}>
                <h2>Current</h2>
                <p style={{marginBottom: 48, marginTop: 12, maxWidth: 200}}>{"Client: " + project.client}</p>
                <p style={{marginBottom: 48, maxWidth: 200}}>{"Address: " + project.address}</p>
                <p style={{marginBottom: 48, maxWidth: 200}}>{"City: " + project.city}</p>
                <p style={{marginBottom: 48, maxWidth: 200}}>{"Start Time: " + moment(project.startTime, "YYYY-MM-DD hh:mm").format('h:mm a')}</p>
                <p style={{marginBottom: 48, maxWidth: 200}}>{"End Time: " + moment(project.endTime, "YYYY-MM-DD hh:mm").format('h:mm a')}</p>
                <p style={{marginBottom: 48, maxWidth: 200}}>{"Type: " + project.type}</p>
                <p style={{marginBottom: 48, maxWidth: 200}}>{"Workstations: " + project.workstations}</p>
                <p style={{marginBottom: 48, maxWidth: 200}}>{"Google Maps Link: "}</p>
                <p style={{marginBottom: 48, maxWidth: 200}}>{"BART Station: " + project.bartStation}</p>
                <p style={{marginBottom: 48, maxWidth: 200}}>{"BART Distance: " + project.bartDistance}</p>
                <p style={{marginBottom: 48, maxWidth: 200}}>{"Notes: " + project.notes}</p>

                {/* show current contacts */}
                <p style={{marginBottom: 24, maxWidth: 200}}>
                  {"Primary: " + (curPrimary.nameTitle || "")}<br/>
                  {"Phone: " + (curPrimary.phone || "")}
                </p>
                <p style={{marginBottom: 24, maxWidth: 200}}>
                  {"Alternate: " + (curAlternate.nameTitle || "")}<br/>
                  {"Phone: " + (curAlternate.phone || "")}
                </p>
                <p style={{marginBottom: 24, maxWidth: 200}}>
                  {"Onsite: " + (curOnsite.nameTitle || "")}<br/>
                  {"Phone: " + (curOnsite.phone || "")}
                </p>
              </Card>
          </Col>


          <Col style={{marginLeft: 0, marginRight: 0}}>
              <Card className="rightCard">
                <h2 style={{marginLeft: -15}}>New</h2>

                <Row className="formRows">
                  <Form.Group style={{maxWidth: "80%"}} controlId="client">
                    <Form.Control
                      type="text"
                      placeholder={project.client}
                      onChange={handleEditProject}
                      required
                    />
                  </Form.Group>

                  {editedProjectState.client && (
                    <IconContext.Provider value={{ color: 'green', className: "global-class-name" }}>
                      <FaCircle className="greenDot"/>
                    </IconContext.Provider>
                  )}
                </Row>

                <Row className="formRows">
                  <Form.Group style={{maxWidth: "80%"}} controlId="address">
                    <Form.Control
                      type="text"
                      placeholder={project.address}
                      onChange={handleEditProject}
                      required
                    />
                  </Form.Group>

                  {editedProjectState.address && (
                    <IconContext.Provider value={{ color: 'green', className: "global-class-name" }}>
                      <FaCircle className="greenDot"/>
                    </IconContext.Provider>
                  )}
                </Row>

                <Row className="formRows">
                  <Form.Group style={{maxWidth: "80%"}} controlId="city">
                    <Form.Control
                      type="text"
                      placeholder={project.city}
                      onChange={handleEditProject}
                      required
                    />
                  </Form.Group>

                  {editedProjectState.city && (
                    <IconContext.Provider value={{ color: 'green', className: "global-class-name" }}>
                      <FaCircle className="greenDot"/>
                    </IconContext.Provider>
                  )}
                </Row>

                <Row className="formRows">
                  <Form.Group controlId="startTime">
                    <Form.Control
                      type="time"
                      placeholder={moment(project.startTime, "YYYY-MM-DD hh:mm").format('h:mm a')}
                      onChange={handleEditProject}
                      required
                    />
                  </Form.Group>

                  {editedProjectState.startTime && (
                    <IconContext.Provider value={{ color: 'green', className: "global-class-name" }}>
                      <FaCircle className="greenDot"/>
                    </IconContext.Provider>
                  )}
                </Row>

                <Row className="formRows">
                  <Form.Group controlId="endTime">
                    <Form.Control
                      type="time"
                      placeholder={moment(project.endTime, "YYYY-MM-DD hh:mm").format('h:mm a')}
                      onChange={handleEditProject}
                      required
                    />
                  </Form.Group>

                  {editedProjectState.endTime && (
                    <IconContext.Provider value={{ color: 'green', className: "global-class-name" }}>
                      <FaCircle className="greenDot"/>
                    </IconContext.Provider>
                  )}
                </Row>

                <Row className="formRows">
                  <Form.Group controlId="type" style={{marginTop: 13, marginBottom: 28}}>
                    <Form.Control
                      as="select"
                      placeholder={project.type}
                      onChange={handleEditProject}
                      required
                    >
                      <option></option>
                      <option>Disconnect</option>
                      <option>Reconnect</option>
                      <option>Shuffle</option>
                      <option>Post-move</option>
                      <option>Server</option>
                      <option>Support</option>
                    </Form.Control>
                  </Form.Group>

                  {editedProjectState.type && (
                    <IconContext.Provider value={{ color: 'green', className: "global-class-name" }}>
                      <FaCircle className="greenDot"/>
                    </IconContext.Provider>
                  )}
                </Row>

                <Row className="formRows">
                  <Form.Group style={{maxWidth: "80%"}} controlId="workstations">
                    <Form.Control
                      type="number"
                      placeholder={project.workstations}
                      onChange={handleEditProject}
                      required
                    />
                  </Form.Group>

                  {editedProjectState.workstations && (
                    <IconContext.Provider value={{ color: 'green', className: "global-class-name" }}>
                      <FaCircle className="greenDot"/>
                    </IconContext.Provider>
                  )}
                </Row>

                <Row className="formRows">
                  <Form.Group style={{maxWidth: "80%"}} controlId="addressLink">
                    <Form.Control
                      type="text"
                      placeholder={project.addressLink}
                      onChange={handleEditProject}
                    />
                  </Form.Group>

                  {editedProjectState.addressLink && (
                    <IconContext.Provider value={{ color: 'green', className: "global-class-name" }}>
                      <FaCircle className="greenDot"/>
                    </IconContext.Provider>
                  )}
                </Row>

                <Row className="formRows">
                  <Form.Group style={{maxWidth: "80%"}} controlId="bartStation">
                    <Form.Control
                      type="text"
                      placeholder={project.bartStation}
                      onChange={handleEditProject}
                    />
                  </Form.Group>

                  {editedProjectState.bartStation && (
                    <IconContext.Provider value={{ color: 'green', className: "global-class-name" }}>
                      <FaCircle className="greenDot"/>
                    </IconContext.Provider>
                  )}
                </Row>

                <Row className="formRows">
                  <Form.Group style={{maxWidth: "80%"}} controlId="bartDistance">
                    <Form.Control
                      type="number"
                      placeholder={project.bartDistance}
                      onChange={handleEditProject}
                    />
                  </Form.Group>

                  {editedProjectState.bartDistance && (
                    <IconContext.Provider value={{ color: 'green', className: "global-class-name" }}>
                      <FaCircle className="greenDot"/>
                    </IconContext.Provider>
                  )}
                </Row>

                <Row className="formRows">
                  <Form.Group style={{maxWidth: "80%"}} controlId="notes">
                    <Form.Control
                      type="text"
                      placeholder={project.notes}
                      onChange={handleEditProject}
                    />
                  </Form.Group>

                  {editedProjectState.notes && (
                    <IconContext.Provider value={{ color: 'green', className: "global-class-name" }}>
                      <FaCircle className="greenDot"/>
                    </IconContext.Provider>
                  )}
                </Row>

                {/* contacts editor (minimal, no refactor) */}
                <div style={{marginTop: 18}}>
                  <h4 style={{marginLeft: -15, marginBottom: 12}}>Contacts</h4>

                  <Row className="formRows">
                    <Form.Group style={{maxWidth: "80%"}}>
                      <Form.Label style={{marginBottom: 4}}>Primary (Name/Title)</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder={curPrimary.nameTitle || "Jane Doe / Facilities"}
                        data-contact-type="primary"
                        data-field="nameTitle"
                        onChange={handleContactEdit}
                      />
                    </Form.Group>
                    {editedProjectState.contacts.primary.nameTitle && (
                      <IconContext.Provider value={{ color: 'green', className: "global-class-name" }}>
                        <FaCircle className="greenDot"/>
                      </IconContext.Provider>
                    )}
                  </Row>

                  <Row className="formRows">
                    <Form.Group style={{maxWidth: "80%"}}>
                      <Form.Label style={{marginBottom: 4}}>Primary Phone</Form.Label>
                      <Form.Control
                        type="tel"
                        placeholder={curPrimary.phone || "(555) 555-5555"}
                        data-contact-type="primary"
                        data-field="phone"
                        onChange={handleContactEdit}
                      />
                    </Form.Group>
                    {editedProjectState.contacts.primary.phone && (
                      <IconContext.Provider value={{ color: 'green', className: "global-class-name" }}>
                        <FaCircle className="greenDot"/>
                      </IconContext.Provider>
                    )}
                  </Row>

                  <Row className="formRows">
                    <Form.Group style={{maxWidth: "80%"}}>
                      <Form.Label style={{marginBottom: 4}}>Alternate (Name/Title)</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder={curAlternate.nameTitle || "John Smith / IT"}
                        data-contact-type="alternate"
                        data-field="nameTitle"
                        onChange={handleContactEdit}
                      />
                    </Form.Group>
                    {editedProjectState.contacts.alternate.nameTitle && (
                      <IconContext.Provider value={{ color: 'green', className: "global-class-name" }}>
                        <FaCircle className="greenDot"/>
                      </IconContext.Provider>
                    )}
                  </Row>

                  <Row className="formRows">
                    <Form.Group style={{maxWidth: "80%"}}>
                      <Form.Label style={{marginBottom: 4}}>Alternate Phone</Form.Label>
                      <Form.Control
                        type="tel"
                        placeholder={curAlternate.phone || "(555) 555-5555"}
                        data-contact-type="alternate"
                        data-field="phone"
                        onChange={handleContactEdit}
                      />
                    </Form.Group>
                    {editedProjectState.contacts.alternate.phone && (
                      <IconContext.Provider value={{ color: 'green', className: "global-class-name" }}>
                        <FaCircle className="greenDot"/>
                      </IconContext.Provider>
                    )}
                  </Row>

                  <Row className="formRows">
                    <Form.Group style={{maxWidth: "80%"}}>
                      <Form.Label style={{marginBottom: 4}}>Onsite (Name/Title)</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder={curOnsite.nameTitle || "Reception / Front Desk"}
                        data-contact-type="onsite"
                        data-field="nameTitle"
                        onChange={handleContactEdit}
                      />
                    </Form.Group>
                    {editedProjectState.contacts.onsite.nameTitle && (
                      <IconContext.Provider value={{ color: 'green', className: "global-class-name" }}>
                        <FaCircle className="greenDot"/>
                      </IconContext.Provider>
                    )}
                  </Row>

                  <Row className="formRows">
                    <Form.Group style={{maxWidth: "80%"}}>
                      <Form.Label style={{marginBottom: 4}}>Onsite Phone</Form.Label>
                      <Form.Control
                        type="tel"
                        placeholder={curOnsite.phone || "(555) 555-5555"}
                        data-contact-type="onsite"
                        data-field="phone"
                        onChange={handleContactEdit}
                      />
                    </Form.Group>
                    {editedProjectState.contacts.onsite.phone && (
                      <IconContext.Provider value={{ color: 'green', className: "global-class-name" }}>
                        <FaCircle className="greenDot"/>
                      </IconContext.Provider>
                    )}
                  </Row>
                </div>

              </Card>
          </Col>
        </Row>

      </Container>

      <Button
        variant="success"
        size="sm"
        disabled={!anythingChanged}
        onClick={() => confirmChanges(project)}>
          Confirm Changes
      </Button>
      &nbsp;

      {!anythingChanged && (
        <Button variant="primary" size="sm" onClick={closeModal}> Go Back </Button>
      )}

      {anythingChanged && (
        <Button variant="danger"  size="sm" onClick={discardChanges}> Discard Changes </Button>
      )}
      </Modal>
    </div>
  );
}

const mapDispatchToProps = dispatch => {
  return {
    updateProjectDetail: (refLocation, detailToUpdate, valueToUse) => dispatch(updateProjectDetail(refLocation, detailToUpdate, valueToUse)),
  }
}

export default connect(null, mapDispatchToProps)(EditProject);
